/** @typedef {import('../models/photo-entity').default} PhotoEntity */

export default class PhotosState {
  static initial() {
    return new PhotosState({
      backwardPhoto: null,
      currentPhoto: null,
      forwardPhoto: null,
      loading: false,
      error: false,
    })
  }

  /**
   * Creates an instance of PhotosState.
   * @param {Object} settings
   * @param {?PhotoEntity} settings.backwardPhoto
   * @param {?PhotoEntity} settings.currentPhoto
   * @param {?PhotoEntity} settings.forwardPhoto
   * @param {Boolean} settings.loading
   * @param {Boolean} settings.error
   * @memberof PhotosState
   */
  constructor({ backwardPhoto, currentPhoto, forwardPhoto, loading, error }) {
    this.backwardPhoto = backwardPhoto
    this.currentPhoto = currentPhoto
    this.forwardPhoto = forwardPhoto
    this.loading = loading
    this.error = error
  }

  /**
   * @param {Object} settings
   * @param {?PhotoEntity} settings.backwardPhoto
   * @param {?PhotoEntity} settings.currentPhoto
   * @param {?PhotoEntity} settings.forwardPhoto
   * @param {Boolean} settings.loading
   * @param {Boolean} settings.error
   * @returns
   * @memberof PhotosState
   */
  copyWith({ backwardPhoto, currentPhoto, forwardPhoto, loading, error }) {
    return new PhotosState({
      backwardPhoto: backwardPhoto !== undefined ? backwardPhoto : this.backwardPhoto,
      currentPhoto: currentPhoto !== undefined ? currentPhoto : this.currentPhoto,
      forwardPhoto: forwardPhoto !== undefined ? forwardPhoto : this.forwardPhoto,
      loading: loading !== undefined ? loading : this.loading,
      error: error !== undefined ? error : this.error,
    })
  }

  /**
   * @param {PhotosState} state
   * @returns {Boolean}
   * @memberof PhotosState
   */
  equals(state) {
    if (
      this.backwardPhoto !== state.backwardPhoto ||
      this.currentPhoto !== state.currentPhoto ||
      this.forwardPhoto !== state.forwardPhoto ||
      this.loading !== state.loading ||
      this.error !== state.error
    ) {
      return false
    }

    return true
  }
}
